
  import React from "react"
  import Component from "/Users/fabian/FabeZone/erstberatungsportal.de/src/layouts/index.js"
  import data from "/Users/fabian/FabeZone/erstberatungsportal.de/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js